import { useRuntimeConfig } from '#imports'

/**
 * Client autonome (exe solo hors ligne) : build `NUXT_PUBLIC_STANDALONE=true`.
 * Chat, social, classements et fin de service V2 y sont masqués.
 */
export function isStandaloneClient(): boolean {
  return useRuntimeConfig().public.standalone === true
}

/** Routes sans intérêt hors ligne (un seul joueur). */
export const STANDALONE_HIDDEN_NAV_PATHS = ['/players', '/leaderboard']
